export interface Atmosphere {
  /** kg/m³ al livello del mare */
  readonly seaLevelDensity: number
  /** Pa al livello del mare */
  readonly seaLevelPressure: number
  /** altezza di scala H, in metri */
  readonly scaleHeight: number
  /** quota oltre la quale l'atmosfera e considerata assente, in metri */
  readonly ceiling: number
}

function factor(atm: Atmosphere, altitude: number): number {
  if (altitude >= atm.ceiling) return 0
  const h = Math.max(0, altitude)
  return Math.exp(-h / atm.scaleHeight)
}

export function densityAt(atm: Atmosphere | null, altitude: number): number {
  return atm === null ? 0 : atm.seaLevelDensity * factor(atm, altitude)
}

export function pressureAt(atm: Atmosphere | null, altitude: number): number {
  return atm === null ? 0 : atm.seaLevelPressure * factor(atm, altitude)
}

/** Rapporto p/p₀ in [0,1]: e questo che pilota spinta e Isp. */
export function pressureRatio(atm: Atmosphere | null, altitude: number): number {
  return atm === null ? 0 : factor(atm, altitude)
}
